import {
  Component,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  CampaignSummaryComponent,
  DonationSummaryVM,
} from '../summary/summary.component';

export interface PopupCampaignVM extends DonationSummaryVM {
  id: string;
}

@Component({
    selector: 'don-campaign-carousel',
    imports: [CommonModule, CampaignSummaryComponent],
    templateUrl: './campaign-carousel.component.html',
    styleUrls: ['./campaign-carousel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CampaignCarouselComponent implements OnChanges {
  /** Lista de campañas para el carrusel */
  @Input({ required: true }) campaigns: PopupCampaignVM[] = [];
  /** Campaña seleccionada desde afuera (NgRx) */
  @Input() selectedId: string | null = null;

  /** Emite el id de la campaña seleccionada */
  @Output() select = new EventEmitter<string>();

  index = 0;

  ngOnChanges(): void {
    if (!this.campaigns?.length) return;
    // Coloca el slide en el seleccionado actual si viene del store
    if (this.selectedId) {
      const i = this.campaigns.findIndex((c) => c.id === this.selectedId);
      this.index = i >= 0 ? i : 0;
    } else {
      this.index = 0;
    }
  }

  goTo(i: number) {
    if (i < 0 || i >= this.campaigns.length) return;
    this.index = i;
    const current = this.campaigns[this.index];
    if (current) this.select.emit(current.id);
  }

  trackById = (_: number, c: PopupCampaignVM) => c.id;
}
